<template>
  <div>
    <c-box
      title="Устройства входа"
      shadow
      header-divider
      :loading="loading"
    >
      <template v-slot:header-right>
        <form class="form-inline">
          <div class="form-group">
            Диаграмма
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="diagram"
              >
            </label>
            Таблица
            <label>
              <input
                v-model="view"
                type="radio"
                class="minimal"
                value="table"
              >
            </label>
          </div>
        </form>
      </template>

      <template v-if="!loading && data.length">
        <table
          v-if="view === 'table'"
          class="table"
        >
          <thead>
            <tr>
              <th>Устройства входа</th>
              <th>Визиты</th>
              <th>Просмотры</th>
              <th>Отказы</th>
              <th>Время на сайте</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item of data"
              :key="item.УстройстваВхода"
            >
              <td v-text="item.УстройстваВхода" />
              <td v-text="item.Визиты" />
              <td v-text="item.Просмотры" />
              <td v-text="item.Отказы" />
              <td v-text="item.ВремяСтрока" />
            </tr>
          </tbody>
        </table>
        <div
          v-else
          class="row"
        >
          <div class="col-md-7">
            <metrics-table :data="data.map(i => ({name: i.УстройстваВхода, visits: i.Визиты}))" />
          </div>
          <div class="col-md-5">
            <c-doughnut-chart
              class="doughnut-chart"
              :chart-data="chartData"
              :options="chartOptions"
            />
          </div>
        </div>
      </template>
      <no-data v-if="!loading && !data.length" />
    </c-box>

    <p
      v-if="conclusion"
      v-html="conclusionHtml"
    />
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import sengine from '../../../../../../../resources/js/mixins/sengine'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'
import MetricsTable from '../../../../../../../resources/js/components/MetricsTable.vue'
import CDoughnutChart from '../../../../../../../resources/js/components/ui/CDoughnutChart.vue'
import { conclusion1CToHtml } from '../../../../../../../resources/js/helper'

export default {
  name: 'TrafficDevices',
  components: { CDoughnutChart, MetricsTable, NoData, CBox },
  mixins: [sengine, diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    conclusion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      view: 'table',
      chartOptions: {
        legend: {
          display: false
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        tooltips: {
          callbacks: {
            label (tooltipItem, data) {
              return data.labels[tooltipItem.index] + ': ' + data.datasets[0].data[tooltipItem.index] + '%'
            }
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  computed: {
    chartData () {
      return {
        labels: this.data.map(i => i.УстройстваВхода),
        datasets: [
          {
            data: this.data.map(i => i.ДоляВОбщемЧислеВизитов),
            backgroundColor: this.data.map((item, index) => this.getNextDiagramColor(index))
          }
        ]
      }
    },
    conclusionHtml () {
      return conclusion1CToHtml(this.conclusion)
    }
  }
}
</script>
